/* BEBA: keep Stord Shipment Protection on the same Subscribe & Save plan as the subscription in the cart,
   so protection renews with every subscription order (Stord matches plans by name).
   Runs only when a cart response contains the Stord protection item; one-time carts are untouched.
   If the cart mixes different delivery frequencies, protection stays one-time. */
(function(){
  if(window.__bebaSpSubs)return;window.__bebaSpSubs=true;
  const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  const isSp=h=>/^stord-(sp-pricing-|shipment-protection)/.test(h||'');
  const J={'Content-Type':'application/json',Accept:'application/json'};
  const prodCache={};
  function product(raw,handle){if(!prodCache[handle])prodCache[handle]=raw(root+'products/'+handle+'.js',{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).catch(()=>null);return prodCache[handle]}
  async function attachPlan(raw){
    const cart=await raw(root+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
    const subs=cart.items.filter(i=>!isSp(i.handle)&&i.selling_plan_allocation);
    if(!subs.length)return;
    const names=[...new Set(subs.map(i=>i.selling_plan_allocation.selling_plan.name.trim().toLowerCase()))];
    if(names.length!==1)return;
    for(const line of cart.items.filter(i=>isSp(i.handle)&&!i.selling_plan_allocation)){
      const p=await product(raw,line.handle);if(!p)continue;
      const v=p.variants.find(x=>x.id===line.variant_id);if(!v)continue;
      const a=(v.selling_plan_allocations||[]).find(x=>{const g=p.selling_plan_groups.find(g=>g.id===x.selling_plan_group_id);const sp=g&&g.selling_plans.find(s=>s.id===x.selling_plan_id);return sp&&sp.name.trim().toLowerCase()===names[0]});
      if(!a)continue;
      await raw(root+'cart/change.js',{method:'POST',headers:J,body:JSON.stringify({id:line.key,quantity:line.quantity,selling_plan:a.selling_plan_id})});
    }
  }
  const orig=window.fetch.bind(window);
  window.fetch=async function(input,init){
    const res=await orig(input,init);
    try{
      const url=String(input&&input.url||input);
      if(res.ok&&/\/cart\/(add|update|change)(\.js)?(\?|$)/.test(url)){
        const body=await res.clone().json().catch(()=>null);
        const items=body?(body.items||[body]):[];
        if(items.some(i=>isSp(i.handle)))await attachPlan(orig);
      }
    }catch(e){}
    return res;
  };
})();
